import React from "react";
import { startCase } from "lodash";
import styled from "styled-components";
import Image from "react-bootstrap/Image";

const Voters = ({ data }) => {
  const otherData = data?.other_data;

  return (
    <Wrapper>
      <Image src="/cards/voters.png" className="wrapper__background" />
      <div className="content">
        <div className="content__item content__image">
          <Image src={`data:image/png;base64, ${data?.picture}`} />
        </div>

        <div className="content__item content__station-code">
          {otherData?.PollingStation || data?.polling_station || ""}
        </div>
        <div className="content__item content__id">
          {otherData?.VoterID || data?.voter_id || ""}
        </div>
        <div className="content__item content__age">
          {otherData?.Age || data?.age || ""}
        </div>
        <div className="content__item content__sex">
          {startCase(data?.sex || data?.gender || "")}
        </div>
        <div className="content__item content__date">
          {data?.registration_date || ""}
        </div>
        <div className="content__item content__name">
          {otherData?.Fullname?.toUpperCase() ||
            (data?.first_name + " " + data?.last_name).toLowerCase() ||
            ""}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 290px;
  height: 190px;
  position: relative;
  img.wrapper__background {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    &__item {
      color: #000;
      font-size: 9px;
      font-weight: 500;
      line-height: 7px;
      position: absolute;
    }
    &__image {
      top: 24px;
      right: 15px;
      width: 84px;
      height: 114px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__station-code {
      top: 32px;
      left: 89px;
      font-weight: 600;
    }
    &__id {
      top: 50px;
      left: 50px;
    }
    &__age {
      top: 95px;
      left: 50px;
    }
    &__sex {
      top: 113px;
      left: 50px;
    }
    &__date {
      top: 132px;
      left: 80px;
    }
    &__name {
      top: 150px;
      left: 50px;
    }
  }
`;

export default Voters;
